import styled from "styled-components";

export const InfoBadgesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const InfoBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.color || "#002244"};
  background-color: ${(props) => props.background || "#EFF6FF"};
  border: 1px solid ${(props) => props.borderColor || "#DBEAFE"};
`;

export const ActiveSessionsList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 18px;
  font-family: Open Sans;
  font-size: 14px;
  color: #3a3a3c;
  text-align: left;

  & > li {
    margin-bottom: 2px;
  }
`;
